import { render, staticRenderFns } from "./preDetail.vue?vue&type=template&id=a41aed5a&scoped=true"
import script from "./preDetail.vue?vue&type=script&lang=js"
export * from "./preDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./preDetail.vue?vue&type=style&index=1&id=a41aed5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41aed5a",
  null
  
)

export default component.exports